import { FileText } from 'lucide-react';
import { EmptyState } from '@aaimplatform/ui';

/**
 * Electronic Signatures Page
 *
 * Members sign their pledge contracts on the Aaim platform: the in-house,
 * single-signer capture that flips a contract to FULLY_EXECUTED, observed on
 * prod 2026-09-15 (critical-path steps 7 and 8). No FI-facing list of those
 * executed instruments exists yet: there is no canonical /api/v1/signatures
 * backend, and the prior implementation consumed a dead
 * contract-documentation stub (bare /api/signatures, unrouted at the
 * admin.aaim.com load balancer; its only handler returned an empty list and
 * 501 for writes).
 *
 * Rather than present create/void/resend controls that cannot persist, the
 * page states where signing happens and that this view is not built.
 */
export function SignaturesPage() {
  return (
    <div>
      <div className="mb-6">
        {/* Page title lives in the sticky topnav (AppHeader); the body opens
            with the descriptive subtitle, no redundant H1. */}
        <p className="text-sm font-sans text-tertiary">
          Executed pledge and collateral agreements
        </p>
      </div>

      <EmptyState
        icon={<FileText className="h-8 w-8" />}
        title="Executed agreements are not listed here yet"
        description="Members sign their pledge contracts on the Aaim platform. A list of those executed contracts for your institution has not been built."
      />
    </div>
  );
}
